import { IHttpRequestConfig, post, put } from "@/browser";
import { applyHeaders, extractDataFromResponse } from "@/core/api";
import { compose } from "@/core/url";
import { IConsultantProfile } from "@/data/consultant-profiles";

import { IManagerInvitation, IManagerInvitationDto, managerInvitationType } from "./types";

const API = {
  post: "/api/manager-invitations",
  resend: "/api/manager-invitations/{invitationId}/resend",
  sendToNotInvited: "/api/manager-invitations/invite-not-invited",
};

export interface IPostManagerInvitationParams {
  companyId: number;
}

export const postManagerInvitation = (
  params: IPostManagerInvitationParams,
  data: IManagerInvitationDto,
  options?: IHttpRequestConfig,
) => {
  const { companyId } = params;
  return post<IManagerInvitation>(API.post, data, applyHeaders({ companyId }, options))
    .then(extractDataFromResponse)
    .then(managerInvitationType);
};

export interface IResendManagerInvitationParams {
  invitationId: number;
  companyId?: number;
}

export const resendManagerInvitation = (params: IResendManagerInvitationParams, options?: IHttpRequestConfig) => {
  const url = compose(API.resend, params);
  const { companyId } = params;
  return put<IManagerInvitation>(url, {}, applyHeaders({ companyId }, options))
    .then(extractDataFromResponse)
    .then(managerInvitationType);
};

export interface ISendManagerInvitationToNotInvitedParams {
  companyId: number;
}

export const sendManagerInvitationToNotInvited = (
  params: ISendManagerInvitationToNotInvitedParams,
  data: Pick<IConsultantProfile, "id" | "signature">,
  options?: IHttpRequestConfig,
) => {
  const { companyId } = params;
  return post<IManagerInvitation>(
    API.sendToNotInvited,
    { consultantProfile: data },
    applyHeaders({ companyId }, options),
  )
    .then(extractDataFromResponse)
    .then(managerInvitationType);
};
